const API_URL = process.env.REACT_APP_API_URL || '/api';

/** Nom de fichier annoncé par le serveur dans Content-Disposition. */
function nomDepuisEntete(entete, defaut) {
  const trouve = /filename="?([^"]+)"?/.exec(entete || '');
  return trouve ? trouve[1] : defaut;
}

/**
 * Télécharge l'export Excel d'une liste et déclenche l'enregistrement.
 *
 * Passe par fetch plutôt qu'un simple lien : le classeur est produit à la
 * volée (quelques centaines de lignes à mettre en forme), on a besoin de
 * savoir quand c'est fini pour rendre le bouton, et une erreur du serveur
 * doit remonter lisiblement plutôt que d'ouvrir un onglet blanc.
 *
 * `filtres` reprend les filtres de l'écran : le serveur rappelle la même
 * liste, donc le classeur contient exactement ce que la page affiche.
 */
export async function telechargerExcel(chemin, filtres = {}) {
  const query = new URLSearchParams();
  for (const [cle, valeur] of Object.entries(filtres)) {
    if (valeur !== undefined && valeur !== null && valeur !== '') query.set(cle, valeur);
  }
  const suffixe = query.toString();

  // credentials : le cookie de session part avec l'appel (cf. api.js).
  const res = await fetch(`${API_URL}${chemin}${suffixe ? `?${suffixe}` : ''}`, {
    credentials: 'include',
  });

  if (!res.ok) {
    let message = `Export impossible (${res.status})`;
    try {
      const corps = await res.json();
      if (corps?.message) message = corps.message;
    } catch {
      /* réponse non JSON : on garde le code HTTP */
    }
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  const nom = nomDepuisEntete(res.headers.get('Content-Disposition'), 'export.xlsx');
  const blob = await res.blob();

  const url = URL.createObjectURL(blob);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nom;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  URL.revokeObjectURL(url);

  return nom;
}
